import { API_CONFIG } from '../../config/api';

export interface GroupDassOverviewResponse {
  success: boolean;
  data: {
    group: {
      id: string;
      groupName: string;
      createdBy: any;
    };
    counts: {
      approvedMembers: number;
      withAssessments: number;
    };
    averages: {
      overall0to42: number;
      depression0to42: number;
      anxiety0to42: number;
      stress0to42: number;
    };
    distribution: {
      high: number;
      moderate: number;
      low: number;
    };
    _debug?: {
      filterYear: string;
      assessmentCount: number;
      usersWithData: number;
    };
  };
}

export const getGroupDassOverview = async (
  token: string,
  groupId: string,
  year?: number
): Promise<GroupDassOverviewResponse> => {
  const yearParam = year ? `?year=${year}` : '';
  const response = await fetch(`${API_CONFIG.ENDPOINTS.GROUPS}/${groupId}/dass-overview${yearParam}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch group DASS overview');
  }

  return data;
};

